export default {
  studyMap_accumulated_class:'累计学时',
  studyMap_grantee:'被授予人',
  studyMap_relearning:'重新学习',
  studyMap_show_certificate:'1105Web-显示结业证书',
  studyMap_check_learn_map0406:'0406Web-查看学习地图',
  studyMap_show_learn_map0405:"0405Web-显示我的学习地图列表",
  studyMap_check_top:'查看排名',
  studyMap_continue_customs:'继续通关',
  studyMap_show_level_rank:'1104Web-显示关卡排名',
  studyMap_go_task_finished:'你已前往任务学习，是否已完成学习？',
  studyMap_resource_invalid:'资源已失效',
  studyMap_accompany_training_task:'陪练任务',
  studyMap_switch_task_level:'1102Web-切换任务关卡',
  studyMap_check_task_top:'1103Web-查看关卡排名',
  studyMap_current_level:'第{TabEnum}关',
  studyMap_show_learn_map1101:'1101Web-显示学习地图详情',
  studyMap_one:'一',
  studyMap_two:'二',
  studyMap_three:'三',
  studyMap_four:'四',
  studyMap_five:'五',
  studyMap_six:'六',
  studyMap_seven:'七',
  studyMap_eigth:'八',
  studyMap_nine:'九',
  studyMap_ten:'十',
  studyMap_eleven:'十一',
  studyMap_twelve:'十二',
  studyMap_thirteen:'十三',
  studyMap_fourteen:'十四',
  studyMap_fifteen:'十五',
  studyMap_ID_cannot_empty:"阶段学习项目id不能为空!",
  studyMap_learn_invalid:'阶段学习项目已失效!',
  studyMap_without_right:'没有权限!'
}
